import React from "react";

type LocationProps = {
  latitude?: number;
  longitude?: number;
};

const LocationSelector: React.FC<LocationProps> = (props: LocationProps) => {
  const { latitude, longitude } = props;
  const [map, updateMap] = React.useState<any>(undefined);

  const id = `id-${Math.random()}-${new Date().getTime() / 1000}`;

  React.useEffect(() => {
    // Modal 设置 destroyOnClose 后，一定要延时添加地图
    // 否则会报找不到dom的异常
    if (map === undefined) {
      setTimeout(() => {
        try {
          let GY: [number, number] = [106.648957, 26.648632]//贵阳地址
          let center: [number, number] = longitude && latitude ? [longitude, latitude] : GY

          const map1 = new window.AMap.Map(id, {
            center: center,
            zoom: 15,
          });

          const traffic = new window.AMap.TileLayer.Traffic({
            zIndex: 10,
          });

          const marker = new window.AMap.Marker({
            position: center,
            icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
          });

          map1.add(new window.AMap.TileLayer.RoadNet());
          map1.add(traffic);
          map1.add(marker);
          updateMap(map1);
        } catch (e) {
          console.log(e);
        }
      }, 100);
    }
  }, [map, id]);

  return <div id={id} className="margin-top-16px width-100p height-640px" />;
};

export default LocationSelector;
